module.exports = __webpack_public_path__ + "static/img/honor.cdd55af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic/honor.jpg
// module id = UfJZ
// module chunks = 11